export function fileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}

export const preloadImage = (src: string) => {
  const existPreloadLink = document.querySelector(`.estimated-preload-link`) as HTMLLinkElement;
  if (!existPreloadLink) {
    const preloadLink = document.createElement('link');
    preloadLink.className = 'estimated-preload-link';
    preloadLink.href = src;
    preloadLink.as = 'image';
    preloadLink.fetchPriority = 'high';
    preloadLink.rel = 'preload';
    preloadLink.type = 'image/png';
    document.head.appendChild(preloadLink);
  } else if (existPreloadLink.href !== src) {
    existPreloadLink.href = src;
  }
};
